/* StarkBall 2.0: confetti burst when the product is added to the cart.
   Listens to the theme's pubsub cartUpdate event (published by product-form.js
   only after a successful /cart/add), so a failed add fires nothing.
   confetti() comes from assets/confetti.min.js (tsparticles confetti bundle).
   NOTE: PUB_SUB_EVENTS is a top-level `const` in constants.js, so it is a global
   lexical binding but NOT a window property — check it with typeof, not window.* */
(function () {
  function burst() {
    if (typeof window.confetti !== 'function') return;
    var base = { zIndex: 10000, disableForReducedMotion: true, ticks: 260 };
    window.confetti(Object.assign({}, base, {
      particleCount: 140, spread: 80, startVelocity: 48, scalar: 1.3, origin: { x: 0.5, y: 0.6 }
    }));
    setTimeout(function () {
      window.confetti(Object.assign({}, base, {
        particleCount: 70, angle: 60, spread: 60, startVelocity: 55, scalar: 1.2, origin: { x: 0, y: 0.75 }
      }));
      window.confetti(Object.assign({}, base, {
        particleCount: 70, angle: 120, spread: 60, startVelocity: 55, scalar: 1.2, origin: { x: 1, y: 0.75 }
      }));
    }, 250);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (data && data.source === 'product-form') burst();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
